import { ACCESS_RIGHTS_TO_PAGES } from "@/constants/accessRights";
import {
	SBS,
	CLS,
	SMC,
	SEE,
	QAS_INTERACTIVE,
	QAS_QUESTION,
	QAS,
	SPR,
	RES,
	SES,
	SEE_CORPUS,
	SMC_CORPUS,
	SMC_MARKS,
	SPR_TRANSCRIPT,
	TTS,
	USER_ROLES,
	USERS,
} from "@/constants/routes";
import smcIcon from "@/assets/smc.png";
import seeIcon from "@/assets/see.png";
import sprIcon from "@/assets/spr.png";
import sbsIcon from "@/assets/sbs.png";
import ttsIcon from "@/assets/tts.png";
import qasIcon from "@/assets/qas.png";
import sesIcon from "@/assets/ses.png";
import clsIcon from "@/assets/cls.png";
import resIcon from "@/assets/res.png";
import usersIcon from "@/assets/users.png";
import { IRoutes } from "./DockPanel.props";

export const routes: IRoutes[] = [
	{
		accessOptions: [
			{ route: SMC, right: ACCESS_RIGHTS_TO_PAGES.SMC_MODELS },
			{ route: SMC_CORPUS, right: ACCESS_RIGHTS_TO_PAGES.SMC_CORPUS },
			{ route: SMC_MARKS, right: ACCESS_RIGHTS_TO_PAGES.SMC_MARKS },
		],
		mainRoute: SMC,
		name: "smc",
		img: smcIcon,
	},
	{
		accessOptions: [
			{ route: SEE, right: ACCESS_RIGHTS_TO_PAGES.SEE_MODELS },
			{ route: SEE_CORPUS, right: ACCESS_RIGHTS_TO_PAGES.SEE_CORPUS },
		],
		mainRoute: SEE,
		name: "see",
		img: seeIcon,
	},
	{
		accessOptions: [
			{ route: SPR, right: ACCESS_RIGHTS_TO_PAGES.SPR_QUEUE },
			{ route: SPR_TRANSCRIPT, right: ACCESS_RIGHTS_TO_PAGES.SPR_TRANSCRIPT },
		],
		mainRoute: SPR,
		name: "spr",
		img: sprIcon,
	},
	{ accessOptions: [{ route: SBS, right: ACCESS_RIGHTS_TO_PAGES.SBS }], mainRoute: SBS, name: "sbs", img: sbsIcon },
	{ accessOptions: [{ route: TTS, right: ACCESS_RIGHTS_TO_PAGES.TTS }], mainRoute: TTS, name: "tts", img: ttsIcon },
	{
		accessOptions: [
			{ route: QAS, right: ACCESS_RIGHTS_TO_PAGES.QAS_DOC },
			{ route: QAS_QUESTION, right: ACCESS_RIGHTS_TO_PAGES.QAS_QUESTION },
			{ route: QAS_INTERACTIVE, right: ACCESS_RIGHTS_TO_PAGES.QAS_INTERACTIVE },
		],
		mainRoute: QAS,
		name: "qas",
		img: qasIcon,
	},
	{ accessOptions: [{ route: SES, right: ACCESS_RIGHTS_TO_PAGES.SES }], mainRoute: SES, name: "ses", img: sesIcon },
	{ accessOptions: [{ route: CLS, right: ACCESS_RIGHTS_TO_PAGES.CLS }], mainRoute: CLS, name: "cls", img: clsIcon },
	{ accessOptions: [{ route: RES, right: ACCESS_RIGHTS_TO_PAGES.RES }], mainRoute: RES, name: "res", img: resIcon },
	{
		accessOptions: [
			{ route: USERS, right: ACCESS_RIGHTS_TO_PAGES.USERS },
			{ route: USER_ROLES, right: ACCESS_RIGHTS_TO_PAGES.USER_ROLES },
		],
		mainRoute: USERS,
		name: "auth",
		img: usersIcon,
	},
];
